var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#316FF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9191 13.963H17.2222V12.3722C17.2222 11.7748 17.6624 11.6355 17.9725 11.6355C18.2819 11.6355 19.8758 11.6355 19.8758 11.6355V9.0092L17.2546 9C14.3449 9 13.6827 10.9588 13.6827 12.2123V13.963H12V16.6693H13.6827C13.6827 20.1424 13.6827 24.3272 13.6827 24.3272H17.2222C17.2222 24.3272 17.2222 20.1012 17.2222 16.6693H19.6105L19.9191 13.963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter4);
export default __webpack_public_path__ + "static/media/footer4.3b554c7fc4239155a067c2c8281b3918.svg";
export { ForwardRef as ReactComponent };